var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnresolvedSubscriptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 100,
    viewBox: "0 0 118 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1239 15.6106C20.6044 20.6298 12.0922 37.2798 17.1114 52.7993L24.4955 75.631C29.5147 91.1505 46.1647 99.6626 61.6842 94.6434C77.2037 89.6242 85.7158 72.9742 80.6966 57.4547L80.2706 56.1375L72.3673 58.6936L72.7933 60.0108C76.4009 71.1654 70.2828 83.1326 59.1281 86.7401C47.9735 90.3477 36.0064 84.2296 32.3988 73.0749L25.0147 50.2432C21.4071 39.0886 27.5252 27.1215 38.6799 23.5139C49.8345 19.9063 61.8017 26.0244 65.4092 37.1791L65.8352 38.4963L73.7385 35.9403L73.3125 34.6231C68.2933 19.1035 51.6434 10.5914 36.1239 15.6106Z",
    fill: "#013583"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.4813,
    y: 67.0684,
    width: 74.757,
    height: 74.757,
    rx: 3.6917,
    transform: "rotate(-17.9219 13.4813 67.0684)",
    fill: "#0077AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9269 83.7374C64.416 81.8661 64.9693 79.3079 64.1783 76.8621C62.9235 72.9822 58.761 70.8542 54.8811 72.109C51.0012 73.3638 48.8732 77.5263 50.128 81.4061C50.919 83.8519 52.8654 85.6016 55.1681 86.2465L56.0118 98.6677C56.0525 99.2668 56.6453 99.6681 57.2166 99.4833L69.0175 95.6667C69.5888 95.482 69.8343 94.8095 69.5165 94.3001L62.9269 83.7374Z",
    fill: "#013583"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3045 33.6553L87.118 24.8233",
    stroke: "#50AADE",
    strokeWidth: 1.84585,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4193 37.6591L92.5663 35.671",
    stroke: "#50AADE",
    strokeWidth: 1.84585,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9753 45.5624L93.637 46.4798",
    stroke: "#50AADE",
    strokeWidth: 1.84585,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnresolvedSubscriptions);
export default __webpack_public_path__ + "static/media/unresolved-subscriptions.2bb3d3a440aa8aa9e78916a5dd8afe10.svg";
export { ForwardRef as ReactComponent };